export enum Participant {
  Agent = 'agent',
  User = 'user',
}

export type Participants = `${Participant}`;

export type MessageRecord = {
  readonly owner: Participants;
  readonly content: string;
  readonly type?: string;
};
